export default __webpack_public_path__ + "static/media/01_Go-for-a-swim_Share.ac1fc548.jpg";